import React from "react";
import dictionary from "../../dictionary";
import functions from "../../functions";
import ajax from "../../ajax";
import ActivityLoader from "../Common/ActivityLoader";
import AlertError from "../Common/AlertError";
import TextInput from "../Common/TextInput";
import AlertSuccess from "../Common/AlertSuccess";

class PopAddPrice extends React.Component {
  state = {
    userId: functions.sessionGuard(),
    price: "",
    amount: "",
    info: "",
    loading: false,
  };

  onChangePrice = (event) => {
    this.setState({ price: event.target.value });
  };
  onChangeAmount = (event) => {
    this.setState({ amount: event.target.value });
  };

  onConfirm = (event) => {
    event.preventDefault();
    this.setState(
      {
        info: "",
      },
      async () => {
        const { price,amount } = this.state;

        if (price && amount) {
          const server_response = await ajax.addBettingPrice(price,amount);
          if ((server_response.status = "OK")) {
            this.setState({
              info: <AlertSuccess message={server_response.message} />,
            });
          } else {
            this.setState({
              info: <AlertError message={server_response.message} />,
            });
          }
        } else {
          this.setState({
            info: <AlertError message={dictionary._completeFields} />,
          });
        }
      }
    );
  };

  render() {
    return (
      <>
        <div className="modal" id="modal_add_price">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content modal-content-demo shadow">
              <div className="modal-header">
                <h6 className="modal-title">Add Price</h6>
                <button
                  aria-label="Close"
                  className="close"
                  data-dismiss="modal"
                  type="button"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {this.state.info}
                <form method="post" onSubmit={this.onConfirm}>
                  <TextInput
                    label="Enter Price Name"
                    type="text"
                    onChange={() => this.onChangePrice}
                    value={this.state.price}
                  />
                  <TextInput
                    label="Enter Amount"
                    type="number"
                    onChange={() => this.onChangeAmount}
                    value={this.state.amount}
                  />
                </form>

                {/* <p><i>Cash withdrawn fr.</i></p> */}
              </div>
              {!this.state.loading && (
                <div className="modal-footer">
                  <button
                    className="btn ripple btn-success"
                    type="button"
                    onClick={this.onConfirm}
                  >
                    Add Price
                  </button>
                  <button
                    className="btn ripple btn-secondary"
                    type="button"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              )}

              {this.state.loading && (
                <div className="modal-footer">
                  <ActivityLoader />
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PopAddPrice;
